module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige8-f8684740d19da781a0ab3cec98f77681.jpg";